// extracted by mini-css-extract-plugin
export var buttons = "_bn-0";
export var buttonsActive = "_bn-h";
export var cancelConfirm = "_bn-1";
export var closeButton = "_bn-2";
export var column = "_bn-3";
export var container = "_bn-4";
export var detailHeader = "_bn-6";
export var detailTitle = "_bn-7";
export var detailsContent = "_bn-5";
export var header = "_bn-8";
export var headerWithClose = "_bn-9";
export var icon = "_bn-a";
export var infoIcon = "_bn-c";
export var informationContainer = "_bn-b";
export var sideDrawer = "_bn-d";
export var sideDrawerOpen = "_bn-e";
export var stickyFooter = "_bn-f";
export var typeOption = "_bn-g";